import {
    reactive,
    watch,
} from 'vue'

const useACheckbox = (props, ctx) => {

    const isChecked = () => {
        let checked = false

        if(ctx.attrs.value) {
            checked = props.modelValue.includes(ctx.attrs.value) ? true : false
        } else if (props.checked) {
            checked = true
        } else {
            checked = props.modelValue ? true : false
        }

        return checked
    }

    let store = reactive({
        state: {
            checked: isChecked(),
            ...props.state
        }
    })

    const change = ($e) => {
        
        let val
        
        if(ctx.attrs.value) {
            if($e.target.checked === true) {
                val = props.modelValue.concat(ctx.attrs.value)
                store.state.checked = true
            } else {
                val = props.modelValue
                props.modelValue.splice(props.modelValue.indexOf(ctx.attrs.value), 1)
                store.state.checked = false
            }
        } else {
            val = $e.target.checked ? props.trueValue : props.falseValue
            store.state.checked = val
        }
        
        ctx.emit('update:modelValue', val)
    }

    watch(
        () => props.modelValue,
        () => {
            store.state.checked = isChecked()
        }
    )

    return {
        store,
        change,
    }
}

export {
    useACheckbox
}